/* eslint-disable @typescript-eslint/no-explicit-any */
import create from 'zustand';
import { persist } from 'zustand/middleware';

interface JourneyStoreState {
  formData: any;
  setFormData: (formData: any) => void;
}

export const useJourneyStore = create<JourneyStoreState>(
  persist(
    (set) => ({
      formData: {} as any,
      setFormData: (formData) => set({ formData }),
    }),
    {
      name: 'journey-storage',
      getStorage: () => sessionStorage,
    }
  )
);
